import { createStore, IModuleStore } from 'redux-dynamic-modules';
import { getThunkExtension } from 'redux-dynamic-modules-thunk';
import { getRootModule, RootStateModule } from './getRootModule';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

/**
 * Store type without dynamic modules
 */
export interface PortalStore extends IModuleStore<RootStateModule> {
  dispatch: ThunkDispatch<RootStateModule, undefined, AnyAction>;
}

let store: PortalStore;

export function initStore() {
  return (store = createStore(
    {
      extensions: [getThunkExtension()],
    },
    getRootModule(),
  ));
}

export function getStore() {
  if (!store) {
    return initStore();
  }

  return store;
}
